import { render, staticRenderFns } from "./AppDropdownCheckbox.vue?vue&type=template&id=196414f6&scoped=true&"
import script from "./AppDropdownCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppDropdownCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AppDropdownCheckbox.vue?vue&type=style&index=0&id=196414f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196414f6",
  null
  
)

export default component.exports